import styled from '@emotion/styled';
import {
    boxSizes,
    gutterSizes,
    colorVariables,
    fontWeights,
    fontSizes,
    mediaQuery,
    breakpoints,
} from '@gumtree/ui-library/src/base/theme';
import { Tag } from '@gumtree/ui-library';

export const FilterRowContainer = styled.div`
    padding: 0 16px 12px;
    ${mediaQuery.between(breakpoints.large, breakpoints.xlarge)} {
        padding: 0 0 12px;
    }
`;

export const FilterContainer = styled.div`
    display: flex;
    height: 40px;
    align-items: center;
    align-self: stretch;
    border-radius: ${boxSizes.borderRadius4};
    background-color: ${colorVariables.backgroundLighter};
`;

export const ClearAll = styled.button`
    border: none;
    outline: none;
    background: transparent;
    border-left: 1px solid ${colorVariables.borderLight};
    padding: 0 ${gutterSizes.large};
    line-height: 20px;
    font-size: ${fontSizes.small};
    font-weight: ${fontWeights.light};
    letter-spacing: 0.13px;
    color: ${colorVariables.mainTertiary};
    cursor: pointer;
`;
export const TagList = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    gap: ${gutterSizes.base};
    flex-wrap: wrap;
    margin-top: ${gutterSizes.medium};
    ${mediaQuery.until(breakpoints.large)} {
        margin-top: 0;
        flex-wrap: nowrap;
        width: 100%;
        overflow-x: auto;
    }
`;
export const StyledTag = styled(Tag)`
    background: rgba(230, 236, 238, 0.7);
    color: ${colorVariables.textHighlightedDescription};
    cursor: pointer;
    &:hover {
        background: ${colorVariables.backgroundStriped};
        color: ${colorVariables.textHighlightedDescription};
        font-weight: ${fontWeights.bold};
    }
`;
